import axios from 'axios';
import { has, isObject } from 'underscore';

const Weglot = (<any>window).Weglot;
const weglotKey = (<any>window).DJANGO.weglotKey;

const ttl = 5 * 60 * 1000;

function hashKey(string) {
    let hash = 0, i = 0, len = string.length;

    while ( i < len ) {
        hash  = ((hash << 5) - hash + string.charCodeAt(i++)) << 0;
    }

    return hash
}

function fromStorage(key) {
    const item = localStorage.getItem(key);

    try {
        return JSON.parse(item);
    } catch(e) {
        return null;
    }
}

function fromWeglot(languageTo, languageFrom, words) {
    const options = {
        method: 'POST',
        url: 'https://api.weglot.com/translate?api_key=' + weglotKey,
        data: {
            l_to: languageTo,
            l_from: languageFrom,
            words: words,
            request_url: location.href,
        },
    }

    return axios(options).then(response => {
        const data = response.data;

        if (isObject(data) === false) {
            return null;
        }

        if (has(data, 'to_words') === false || data.to_words.length === 0) {
            return null;
        }

        return data.to_words;
    });
}

function translate(words) {
    // Need the current time so we can check cache expiry
    const time = Date.now();

    const languageTo = Weglot.getCurrentLang();
    const languageFrom = Weglot.options.language_from;

    // Keys are needed for caching
    const keys = words.join();

    // This is the payload for Weglot
    const values = words.map(word => {
        return {
            w: word,
            t: 1,
        }
    });

    // A friendlier return object
    words = words.map(word => {
        return {
            from: word,
            to: word,
        }
    });

    // If from and to are same then there's no need to translate
    if (languageTo === languageFrom) {
        return Promise.resolve(words);
    }

    // Generate a cache key from words
    const cacheKey = languageTo + hashKey(keys);

    // Try to get translation from local storage
    const cached = fromStorage(cacheKey);

    // If we have cached translation and it's not stale
    if (cached && cached.expiry > time) {
        return Promise.resolve(cached.value);
    }

    // Fetch from Weglot
    return fromWeglot(languageTo, languageFrom, values).then(response => {
        // Only store in cache if we have a non-null value
        if (response) {
            // Associate translation to our friendly object
            response.forEach((translation, index) => {
                words[index].to = translation;
            });

            // Cache the friendly object with updated translation
            localStorage.setItem(cacheKey, JSON.stringify({
                value: words,
                expiry: time + ttl,
            }));
        }

        // Return friendly object
        return words;
    });
}

export function translateSingle(word) {
    return translate([word]).then(response => {
        return response[0];
    });
}

export function translateMultiple(words) {
    return translate(words);
}

export default {
    translateSingle,
    translateMultiple,
}



// WEBPACK FOOTER //
// ./@modules/utils/translator.ts